import { useEffect, lazy, Suspense } from 'react';
import './App.css';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import HeroCarousel from './screens/SecondScreen';
import Navbar from './components/Navbar/Navbar';
import SEO from './components/SEO/SEO';
import MinimalHome from './screens/MinimalHome';

// Lazy load below-the-fold components
const AudienceSection = lazy(() => import('./screens/AudienceSection'));
const AboutSection = lazy(() => import('./screens/AboutSection'));
const Testimonials = lazy(() => import('./screens/Testimonials'));
const FlagshipProject = lazy(() => import('./components/Project/Project'));
const WorkProcess = lazy(() => import('./screens/WorkProcess'));
const MixedGallery = lazy(() => import('./screens/Mixed'));
const FAQ = lazy(() => import('./components/FAQ/FAQ'));
const Footer = lazy(() => import('./components/Footer/Footer'));
const FloatingWhatsApp = lazy(() => import('./components/FloatingWhatsApp/FloatingWhatsApp'));
const ChangesApp = lazy(() => import('./changes/ChangesApp'));

// Prevent mobile address bar resize from breaking ScrollTrigger pins
ScrollTrigger.config({ ignoreMobileResize: true });

const FullApp = () => {
  useEffect(() => {
    const handleLoad = () => {
      ScrollTrigger.refresh();
      setTimeout(() => ScrollTrigger.refresh(), 500);
    };
    window.addEventListener('load', handleLoad);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => ScrollTrigger.refresh());
    }
    return () => window.removeEventListener('load', handleLoad);
  }, []);

  return <>
    <SEO/>
    <Navbar/>
    <HeroCarousel/>
    <Suspense fallback={null}>
      <AudienceSection/>
      <AboutSection/>
      <Testimonials/>
      <FlagshipProject/>
      <WorkProcess/>
      <MixedGallery/>
      <FAQ/>
      <Footer/>
      <FloatingWhatsApp/>
    </Suspense>
  </>;
};

function App() {
  const path = typeof window !== 'undefined' ? window.location.pathname : '/';

  if (path.startsWith('/changes')) {
    return (
      <Suspense fallback={null}>
        <ChangesApp />
      </Suspense>
    );
  }

  if (path.startsWith('/full')) {
    return <FullApp />;
  }

  return <MinimalHome />;
}

export default App;
